<template>
  <v-expand-transition>
    <div class="ml-2">
      <v-icon color="green">mdi-check-circle-outline</v-icon>
      <span>Form is valid</span>
    </div>
  </v-expand-transition>
</template>

<script setup lang="ts"></script>

<style scoped lang="css"></style>
